/**
 * @description 判斷是否為聽障人士用
*/
export enum HearingState {
  /** 否 */
  Ability = '0',
  /** 是 */
  Disability = '1'
}
